import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import TextInput from '@/components/common/TextInput';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  'baseMixedTrack' | 'trackData' | 'isMultipleTrack'
> &
  BaseFormGroupProps;

export default function TrackDisplayArtistFormGroup({
  baseMixedTrack,
  isMultipleTrack,
  trackData,
  readonly,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.track.displayArtist"
      className={
        !baseMixedTrack?.displayArtist?.isMixed
          ? 'form-group'
          : 'form-group mixed-display-artist'
      }
    >
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('track.displayArtist')}
        handleInput={() => {}}
        id="displayArtist"
        type="text"
        value={
          !isMultipleTrack
            ? trackData.displayArtist
            : (baseMixedTrack?.displayArtist?.value as string)
        }
        placeholder={
          !baseMixedTrack?.displayArtist?.isMixed ? '' : t('track.mixed')
        }
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={true}
        isReadOnly={readonly}
      />
    </FormGroupWithTooltip>
  );
}
